var _polygon, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.22,247.35a9.44,9.44,0,1,1-9.44-9.44A9.44,9.44,0,0,1,413.22,247.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.75,
    cy: 247.35,
    r: 10.06,
    transform: "translate(-64.85 338.14) rotate(-45)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.21,
    cy: 229.56,
    r: 10.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.84,
    cy: 202.21,
    r: 11.15,
    transform: "translate(89 510.82) rotate(-79.82)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.49,
    cy: 178.27,
    r: 11.52,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.72,
    cy: 168.81,
    r: 12.56,
    transform: "translate(-34.95 163.35) rotate(-22.68)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.61,
    cy: 229.34,
    r: 9.12,
    transform: "translate(104.18 590.19) rotate(-76.77)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 429.48,
    cy: 201.91,
    r: 8.46,
    transform: "translate(-43.8 166.95) rotate(-20.96)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.41,
    cy: 177.95,
    r: 7.73,
    transform: "translate(173.37 559.59) rotate(-80.8)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.26,132.53a38.14,38.14,0,0,1,5.84,8.19l9.32,0,3.47,15-8.4,4.05a38,38,0,0,1-1.66,9.92l6.62,6.57-8.19,13.08-8.8-3.07a37.27,37.27,0,0,1-8.19,5.83l0,9.33-15,3.46-4-8.4a37.33,37.33,0,0,1-9.92-1.66l-6.56,6.62-13.08-8.18,3.07-8.8a38.14,38.14,0,0,1-5.84-8.19l-9.32,0-3.47-15,8.4-4.05a38.08,38.08,0,0,1,1.66-9.92l-6.61-6.57,8.18-13.08,8.8,3.07a37.85,37.85,0,0,1,8.19-5.83l0-9.33,15-3.46,4,8.4a37.67,37.67,0,0,1,9.92,1.66l6.56-6.62,13.09,8.18-3.08,8.8Zm-18.4,12.31a16.55,16.55,0,1,0,5.26,22.81A16.54,16.54,0,0,0,123.86,144.84Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.35,69.3a21.33,21.33,0,0,1,3.23,4.54l5.16,0,1.92,8.32L157,84.38a20.83,20.83,0,0,1-.92,5.5l3.66,3.63-4.53,7.24-4.87-1.7a21,21,0,0,1-4.54,3.23l0,5.17-8.32,1.91-2.24-4.65a20.76,20.76,0,0,1-5.49-.92l-3.64,3.67-7.24-4.53,1.7-4.87a21,21,0,0,1-3.23-4.54l-5.16,0-1.92-8.32L114.94,83a20.83,20.83,0,0,1,.92-5.49l-3.66-3.63,4.52-7.25,4.88,1.71a20.69,20.69,0,0,1,4.53-3.23l0-5.17L134.43,58l2.25,4.66a21.16,21.16,0,0,1,5.49.91l3.64-3.66,7.24,4.53-1.7,4.87Zm-10.19,6.82a9.16,9.16,0,1,0,2.91,12.62A9.16,9.16,0,0,0,141.16,76.12Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.18,79.17a16.73,16.73,0,0,1,2.62,3.67l4.18,0,1.56,6.75-3.77,1.82A16.66,16.66,0,0,1,91,95.84l3,2.94-3.67,5.87-3.94-1.38a17,17,0,0,1-3.68,2.62l0,4.18L76,111.63l-1.81-3.77a17.14,17.14,0,0,1-4.46-.75l-2.94,3-5.87-3.67,1.38-4a16.73,16.73,0,0,1-2.62-3.67l-4.18,0-1.56-6.75,3.77-1.82a17.14,17.14,0,0,1,.75-4.45l-3-2.94L59.13,77l3.95,1.38a16.73,16.73,0,0,1,3.67-2.62V71.56L73.48,70l1.82,3.77a17.07,17.07,0,0,1,4.45.75l2.94-3,5.87,3.67-1.38,4Zm-8.25,5.52a7.42,7.42,0,1,0,2.36,10.23A7.41,7.41,0,0,0,78.93,84.69Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.93,84.69s.15.06.42.23a6,6,0,0,1,1.06.86,7.52,7.52,0,0,1,1.67,8A7.61,7.61,0,0,1,79.7,97a7.69,7.69,0,0,1-4.14,1.62,7.58,7.58,0,0,1-7.67-4.8,7,7,0,0,1-.52-2.23,7.31,7.31,0,0,1,.16-2.2,7.66,7.66,0,0,1,1.86-3.56,7.55,7.55,0,0,1,2.92-1.93,7.41,7.41,0,0,1,5,0,5.68,5.68,0,0,1,1.24.57c.26.17.4.26.39.28s-.57-.33-1.69-.68a7.38,7.38,0,0,0-4.81.19A7.27,7.27,0,0,0,68,89.47a7.17,7.17,0,0,0,.37,4.17,7.24,7.24,0,0,0,2.86,3.44,7.32,7.32,0,0,0,4.35,1.07,6.77,6.77,0,0,0,2.1-.48,6.51,6.51,0,0,0,1.8-1,7.21,7.21,0,0,0,2.78-6.33,7.38,7.38,0,0,0-1.93-4.41C79.48,85.06,78.9,84.73,78.93,84.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.18,79.17s0-.09.07-.25.14-.44.25-.76l1-3,0,.09-5.89-3.63.15,0-2.93,3-.06.06-.08,0a16.68,16.68,0,0,0-4.42-.72H75.2l0-.08-1.83-3.76.19.09-6.74,1.57.14-.18c0,1.29,0,2.72,0,4.18v.12l-.11,0a16.88,16.88,0,0,0-3.62,2.6l-.09.08-.12,0-3.95-1.37.25-.09L55.65,83l0-.27,3,3,.1.09,0,.13a17,17,0,0,0-.73,4.39v.14l-.13.06L54,92.27l.13-.26c.49,2.13,1,4.42,1.56,6.74l-.23-.18,4.18,0h.14l.07.13a16.58,16.58,0,0,0,2.58,3.62h0c0,.11,0-.23.05.24h0v0l0,.06,0,.13-.09.25-.17.49-.35,1-.69,2-.09-.28,5.86,3.67-.29,0,3-3,.1-.1.13,0a16.61,16.61,0,0,0,4.39.74h.14l.06.12c.61,1.27,1.22,2.53,1.81,3.77l-.25-.12,6.75-1.55-.17.21c0-1.42,0-2.81,0-4.18v-.13l.11-.06a16.72,16.72,0,0,0,3.64-2.58l.09-.08.11,0,4,1.38-.23.09c1.29-2.07,2.52-4,3.68-5.86l0,.22-3-3-.08-.08,0-.09a16.58,16.58,0,0,0,.75-4.41v-.09l.08,0,3.78-1.81-.08.16c-.59-2.61-1.09-4.84-1.52-6.75l.1.08H89.75l0,0A17.73,17.73,0,0,0,87.89,80c-.23-.27-.4-.49-.53-.65a2.46,2.46,0,0,1-.18-.21s.08.06.21.19.32.34.56.62a16.84,16.84,0,0,1,1.92,2.83l-.07,0,4.18,0h.09l0,.08c.44,1.91,1,4.13,1.58,6.74l0,.11-.1,0-3.76,1.84.08-.14a17.22,17.22,0,0,1-.73,4.5l0-.17,3,2.93.1.11-.07.12-3.66,5.87-.08.14-.15-.06-4-1.37.2,0a17,17,0,0,1-3.71,2.65l.11-.18c0,1.37,0,2.76,0,4.18v.17l-.17,0L76,111.84l-.17,0-.08-.17c-.6-1.23-1.2-2.49-1.82-3.76l.2.13a17.11,17.11,0,0,1-4.51-.76l.23,0-2.94,3-.14.13-.15-.1-5.87-3.67-.16-.1.06-.18.69-2,.34-1,.18-.5.08-.25,0-.12,0-.06v0h0c.1.47,0,.13.05.23h0a16.59,16.59,0,0,1-2.65-3.72l.2.12-4.18,0h-.19l0-.18c-.53-2.32-1.06-4.61-1.55-6.75l0-.18.16-.08L57.58,90l-.12.2a17.44,17.44,0,0,1,.75-4.51l.06.22-3-3-.13-.12.09-.15L59,76.87l.09-.14.16,0,3.94,1.39-.2,0a17.28,17.28,0,0,1,3.72-2.64l-.1.17c0-1.46,0-2.89,0-4.18v-.15l.14,0,6.75-1.54.13,0,.06.12c.63,1.33,1.24,2.6,1.81,3.77l-.14-.08a17.13,17.13,0,0,1,4.49.77l-.14,0,3-3,.07-.07.08,0,5.84,3.7.05,0,0,0-1.06,2.92c-.12.31-.21.56-.28.75S87.19,79.16,87.18,79.17Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.56,41.68l-29.4-.14A7.31,7.31,0,0,0,290,49l0,5.33a7.3,7.3,0,0,1-7.17,7.43l-57.31-.26a7.31,7.31,0,0,1-7.11-7.5l0-5.33a7.31,7.31,0,0,0-7.11-7.5l-10.34,0L175.22,41A23.13,23.13,0,0,0,152,64l-1.57,371.08a23.14,23.14,0,0,0,23,23.24l151.34.69A23.13,23.13,0,0,0,348,436l1.57-371.08A23.12,23.12,0,0,0,326.56,41.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.56,41.68s.27,0,.79,0a16.54,16.54,0,0,1,2.35.19,21.7,21.7,0,0,1,8.66,3,22.12,22.12,0,0,1,5.25,4.29A23.16,23.16,0,0,1,348,56.16a24.06,24.06,0,0,1,1.69,9.39c0,3.41,0,7,0,10.9-.11,30.83-.27,75.43-.47,130.53s-.47,120.73-.76,193.6q-.06,13.67-.11,27.65c0,2.34,0,4.67,0,7a25.07,25.07,0,0,1-.91,7,23.43,23.43,0,0,1-3,6.49,25.06,25.06,0,0,1-4.82,5.31,23.36,23.36,0,0,1-13.35,5.12c-1.22.08-2.42.06-3.63.05H319l-7.28,0-29.46-.14-60.47-.27-30.93-.14-15.62-.08a24.31,24.31,0,0,1-15-4.21,23.59,23.59,0,0,1-9.09-12.66,25,25,0,0,1-.93-7.82l0-7.8q.06-15.57.13-30.93.13-30.72.26-60.49c.17-39.65.34-77.9.5-114.34s.32-71.06.46-103.46q.11-24.3.21-46.89,0-2.82,0-5.61c0-.93.09-1.87.14-2.8s.24-1.86.48-2.75A23.28,23.28,0,0,1,165.89,42.7a24,24,0,0,1,10.27-1.9l20.17.1L206,41l4.75,0a7.36,7.36,0,0,1,4.53,1.29,7.61,7.61,0,0,1,2.8,3.7,12.44,12.44,0,0,1,.44,4.56c0,.75,0,1.5,0,2.25a16.12,16.12,0,0,0,.07,2.21,7.36,7.36,0,0,0,1.72,3.9,6.78,6.78,0,0,0,3.55,2.22,7.66,7.66,0,0,0,2.09.22h2.13l8.35,0,30.51.17,13.45.07c1.06,0,2.14.06,3.15,0a6.79,6.79,0,0,0,2.85-1,7.34,7.34,0,0,0,3.27-4.66,12.71,12.71,0,0,0,.19-2.82c0-.93,0-1.86,0-2.76a15.18,15.18,0,0,1,.13-2.7,7.83,7.83,0,0,1,.88-2.47,7.34,7.34,0,0,1,3.69-3.24c1.52-.65,3.13-.44,4.59-.47l15,.1,9.23.06c2.08,0,3.14,0,3.14,0h-3.14l-9.23,0-15,0a11.28,11.28,0,0,0-4.52.47,7.06,7.06,0,0,0-3.6,3.17,7.55,7.55,0,0,0-.86,2.41,15.68,15.68,0,0,0-.12,2.67c0,.91,0,1.83,0,2.76a13.23,13.23,0,0,1-.19,2.86,7.55,7.55,0,0,1-3.36,4.8,7,7,0,0,1-2.93,1c-1.07.09-2.11,0-3.18,0L267,61.78l-30.51-.12-8.35,0H226a8,8,0,0,1-2.17-.22,7.14,7.14,0,0,1-3.71-2.31,7.73,7.73,0,0,1-1.8-4.07,18.86,18.86,0,0,1-.07-2.25c0-.75,0-1.5,0-2.25a12.06,12.06,0,0,0-.43-4.45,7.35,7.35,0,0,0-2.68-3.54,7,7,0,0,0-4.34-1.22l-4.75,0-9.71,0-20.16-.09a23.05,23.05,0,0,0-18.57,8.15,23.19,23.19,0,0,0-4.8,9.61c-.24.88-.31,1.8-.48,2.7s-.12,1.83-.13,2.76q0,2.79,0,5.61-.08,22.56-.18,46.89c-.13,32.4-.27,67-.41,103.47s-.31,74.68-.47,114.34q-.12,29.73-.25,60.48-.06,15.36-.13,30.94,0,3.88,0,7.8a24.72,24.72,0,0,0,.91,7.66A23.14,23.14,0,0,0,160.48,454a23.86,23.86,0,0,0,14.72,4.11l15.62.08,30.92.14,60.47.28,29.47.14,7.28,0h3.62c1.21,0,2.42,0,3.6-.05a22.81,22.81,0,0,0,13.06-5,24.35,24.35,0,0,0,4.73-5.2,22.7,22.7,0,0,0,2.91-6.35,24.36,24.36,0,0,0,.9-6.9l0-7q.06-14,.12-27.65c.33-72.87.63-138.49.87-193.6s.49-99.7.64-130.53c0-3.85,0-7.49.06-10.9a23.84,23.84,0,0,0-1.66-9.34,23.21,23.21,0,0,0-4.32-6.89A23.21,23.21,0,0,0,329.69,42a19.38,19.38,0,0,0-2.34-.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.39,158.51l-2.27-2.69,6.76-3.63-31.41-10.63L283.1,172l3.87-5.07s20.32,35.76,0,57.5c-20.18,21.59-44,16.91-44,16.91l4.59,15S285,259,305.09,225.16,299.39,158.51,299.39,158.51Z",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.21,233.55l2.27,2.69-6.77,3.63,31.41,10.63-10.63-30.44-3.86,5.07s-20.33-35.76,0-57.5c20.18-21.59,44-16.91,44-16.91l-4.59-15s-37.45-2.66-57.5,31.16S205.21,233.55,205.21,233.55Z",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.39,158.51l-2.27-2.69,6.76-3.63-31.41-10.63L283.1,172l3.87-5.07s20.32,35.76,0,57.5c-20.18,21.59-44,16.91-44,16.91l4.59,15S285,259,305.09,225.16,299.39,158.51,299.39,158.51Z",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.21,233.55l2.27,2.69-6.77,3.63,31.41,10.63-10.63-30.44-3.86,5.07s-20.33-35.76,0-57.5c20.18-21.59,44-16.91,44-16.91l-4.59-15s-37.45-2.66-57.5,31.16S205.21,233.55,205.21,233.55Z",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.39,158.51l-2.27-2.69,6.76-3.63-31.41-10.63L283.1,172l3.87-5.07s20.32,35.76,0,57.5c-20.18,21.59-44,16.91-44,16.91l4.59,15S285,259,305.09,225.16,299.39,158.51,299.39,158.51Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.21,233.55l2.27,2.69-6.77,3.63,31.41,10.63-10.63-30.44-3.86,5.07s-20.33-35.76,0-57.5c20.18-21.59,44-16.91,44-16.91l-4.59-15s-37.45-2.66-57.5,31.16S205.21,233.55,205.21,233.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.21,178.27a24.42,24.42,0,0,1,3.77,5.31l6,0,2.24,9.73-5.43,2.63a24.52,24.52,0,0,1-1.08,6.42l4.29,4.25-5.3,8.46-5.7-2a24.08,24.08,0,0,1-5.3,3.78l0,6L254,225.11l-2.62-5.44A24.51,24.51,0,0,1,245,218.6l-4.25,4.28-8.47-5.29,2-5.7a24.27,24.27,0,0,1-3.77-5.3l-6,0-2.24-9.73,5.43-2.62a24.46,24.46,0,0,1,1.08-6.42l-4.28-4.25,5.29-8.47,5.7,2a24.41,24.41,0,0,1,5.3-3.78l0-6,9.73-2.25,2.62,5.44a24.12,24.12,0,0,1,6.42,1.08l4.25-4.29,8.47,5.3-2,5.69Zm-11.91,8A10.71,10.71,0,1,0,261.7,201,10.71,10.71,0,0,0,258.3,186.24Z",
    style: {
      fill: "#1A76D2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.3,186.24A10.71,10.71,0,1,0,261.7,201,10.71,10.71,0,0,0,258.3,186.24Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.69,294.79v-6.41h1.18v6.36c0,2.66,1.25,3.87,3.42,3.87s3.44-1.21,3.44-3.87v-6.36h1.15v6.41c0,3.22-1.72,4.88-4.59,4.88S219.69,298,219.69,294.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.2,292.22c0,2.38-1.72,3.82-4.57,3.82h-3v3.53h-1.19V288.38h4.19C239.48,288.38,241.2,289.82,241.2,292.22Zm-1.18,0c0-1.79-1.18-2.82-3.42-2.82h-3V295h3C238.84,295,240,294,240,292.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.76,288.38h4.55c3.58,0,6,2.3,6,5.6s-2.42,5.59-6,5.59h-4.55Zm4.49,10.17c3,0,4.89-1.89,4.89-4.57s-1.92-4.58-4.89-4.58h-3.31v9.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.81,296.58h-6.23l-1.35,3H255l5.12-11.19h1.17l5.11,11.19h-1.24Zm-.43-1-2.68-6-2.69,6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.87,289.4h-3.94v-1H275v1h-3.93v10.17h-1.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.78,298.55v1h-7.91V288.38h7.67v1h-6.49v4h5.79v1h-5.79v4.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.33,77.68c0,.1-4.05.22-9.05.26s-9,0-9-.11,4-.23,9-.27S335.33,77.57,335.33,77.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.37,82.31c0,.11-4.05.23-9.05.27s-9.05,0-9.05-.12,4.05-.22,9.05-.26S335.37,82.21,335.37,82.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.41,86.94c0,.11-4.05.23-9.05.27s-9.06,0-9.06-.12,4.05-.22,9.06-.26S335.41,86.84,335.41,86.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.65,92.23l.37,0,1,0,3.87-.09-.11.11c0-.86,0-1.79,0-2.8,0-.53,0-1,0-1.62a1.49,1.49,0,0,1,1.3-1.19c.62,0,1.17,0,1.85,0a1.51,1.51,0,0,1,1.26,1.49c0,1.31,0,2.68.05,4.09l-.18-.17,4.88,0-.19.18c0-2,0-4,0-6.07,0-.52,0-1,0-1.55a1.55,1.55,0,0,0-.68-1.15l-2.13-2.1-2.06-2-1-1c-.34-.33-.61-.67-1-.75a1.34,1.34,0,0,0-1.12.21c-.3.25-.61.61-.91.9L174,80.34c-1.1,1.14-2.25,2.19-3.08,3.18a3.51,3.51,0,0,0-.25,1.82v1.72c0,1,0,2,0,2.76s0,1.29,0,1.77,0,.63,0,.64a4.72,4.72,0,0,1,0-.58c0-.48,0-1.05,0-1.75s0-1.73-.07-2.79c0-.55,0-1.13,0-1.75,0-.31,0-.63,0-1a2,2,0,0,1,.26-1c.91-1.11,2-2.08,3.09-3.26l1.74-1.78c.31-.31.57-.61.94-.93a1.65,1.65,0,0,1,1.41-.28,2.63,2.63,0,0,1,1.18.84l1,1,2.06,2,2.14,2.1a4,4,0,0,1,.54.59,1.59,1.59,0,0,1,.26.82c0,.51,0,1,0,1.55,0,2.09,0,4.12,0,6.08v.19H185l-4.88,0h-.17v-.17c0-1.42,0-2.79,0-4.09a1.18,1.18,0,0,0-1-1.19c-.56,0-1.23,0-1.77,0a1.18,1.18,0,0,0-1.05.94c0,.49,0,1.07,0,1.56V92.3h-.11l-3.93,0-1,0A2,2,0,0,1,170.65,92.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.5,88.28c0,.14-15.24.26-34,.26s-34-.12-34-.26,15.24-.26,34-.26S290.5,88.14,290.5,88.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.73,404.33H217.28a16.53,16.53,0,0,1-16.53-16.52h0a16.53,16.53,0,0,1,16.53-16.53h71.45a16.53,16.53,0,0,1,16.53,16.53h0A16.53,16.53,0,0,1,288.73,404.33Z",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.37,390.22l.6-1.32a4.42,4.42,0,0,0,2.5.79c1,0,1.47-.34,1.47-.81,0-1.42-4.42-.45-4.42-3.27,0-1.29,1-2.36,3.2-2.36a5.06,5.06,0,0,1,2.64.67l-.54,1.33a4.33,4.33,0,0,0-2.11-.59c-1,0-1.44.39-1.44.87,0,1.4,4.41.43,4.41,3.22,0,1.27-1.05,2.35-3.22,2.35A5.42,5.42,0,0,1,239.37,390.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.53,390.69a2.43,2.43,0,0,1-1.38.37A1.92,1.92,0,0,1,247,389v-2.4h-.9v-1.31h.9v-1.42h1.69v1.42h1.46v1.31h-1.46v2.37a.68.68,0,0,0,.73.77,1.12,1.12,0,0,0,.68-.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.65,387.64V391h-1.59v-.72a1.91,1.91,0,0,1-1.78.81c-1.37,0-2.18-.76-2.18-1.77s.73-1.75,2.51-1.75H255c0-.72-.43-1.15-1.34-1.15a2.77,2.77,0,0,0-1.68.55l-.61-1.19a4.52,4.52,0,0,1,2.52-.7C255.61,385.05,256.65,385.87,256.65,387.64Zm-1.7,1.49v-.6h-1.16c-.79,0-1,.29-1,.68s.36.71.95.71A1.24,1.24,0,0,0,255,389.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.79,385.05v1.56l-.37,0a1.44,1.44,0,0,0-1.56,1.63V391h-1.69v-5.83h1.62v.77A2.33,2.33,0,0,1,261.79,385.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.77,390.69a2.43,2.43,0,0,1-1.38.37,1.93,1.93,0,0,1-2.18-2.09v-2.4h-.9v-1.31h.9v-1.42h1.7v1.42h1.45v1.31h-1.45v2.37a.68.68,0,0,0,.72.77,1.17,1.17,0,0,0,.69-.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.91,325.93c0,.14-30.72.26-68.61.26s-68.62-.12-68.62-.26,30.72-.26,68.62-.26S320.91,325.78,320.91,325.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.57,334.34c0,.14-18.48.26-41.27.26s-41.28-.12-41.28-.26,18.48-.26,41.28-.26S293.57,334.19,293.57,334.34Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-34"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "103.7 458.24 97.62 480.71 117.37 482.51 121.52 461.12 103.7 458.24",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.94,480.68a14.81,14.81,0,0,1-2.89-.1c-1.78-.14-4.23-.41-6.93-.76l-6.9-.93a15.28,15.28,0,0,1-2.85-.49,14.44,14.44,0,0,1,2.89.11c1.78.14,4.23.42,6.93.76l6.9.92A16.64,16.64,0,0,1,117.94,480.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "97.62 480.71 117.37 482.51 117.69 480.86 98.19 478.38 97.64 480.48",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,479.71a85.93,85.93,0,0,1,1.88-8.61,81.92,81.92,0,0,1,2.33-8.5,85.93,85.93,0,0,1-1.88,8.61A85,85,0,0,1,107.43,479.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.85,480.53a9.39,9.39,0,0,0,0-4.17,8.22,8.22,0,0,0-2.16-3.91,8.08,8.08,0,0,0-4.91-2.26,8.39,8.39,0,0,0-5.29,1.2,9.14,9.14,0,0,0-3.07,3.27,11.54,11.54,0,0,0-1.25,4s0-.11,0-.3a6,6,0,0,1,0-.86,8.88,8.88,0,0,1,.94-3A9.18,9.18,0,0,1,104.3,471a8.7,8.7,0,0,1,5.56-1.3,8.13,8.13,0,0,1,7.35,6.56,7.84,7.84,0,0,1,0,3.15,5.81,5.81,0,0,1-.24.82C116.91,480.44,116.86,480.54,116.85,480.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.22,452.21l-1.32,20s19.86,6.59,20,10.31l-38.81.28.78-31.18Z",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172,470.13a1.58,1.58,0,0,0-1.15,1.77,1.52,1.52,0,0,0,1.75,1.16,1.66,1.66,0,0,0,1.2-1.89,1.58,1.58,0,0,0-1.95-1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.07,482.76l.08-3.15,37.48,1a2.69,2.69,0,0,1,1.45,2.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.54,472c0,.19-1,.25-1.92.83s-1.47,1.36-1.64,1.28.14-1.16,1.31-1.85S184.58,471.82,184.54,472Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.55,473.8c0,.18-.79.48-1.46,1.26s-.88,1.63-1.06,1.61-.28-1.09.57-2S188.55,473.62,188.55,473.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.72,478.74c-.18,0-.41-.92.11-1.94s1.41-1.41,1.49-1.25-.49.7-.9,1.54S190.91,478.73,190.72,478.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.33,467.41c-.08.17-.94-.11-2-.07s-1.91.35-2,.18.73-.81,2-.84S184.43,467.27,184.33,467.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.52,463.38a3.64,3.64,0,0,1-1.94-.07,8.66,8.66,0,0,1-2-.68,11.38,11.38,0,0,1-1.1-.63,2.52,2.52,0,0,1-.57-.47.82.82,0,0,1-.06-1,1,1,0,0,1,.85-.41,2.52,2.52,0,0,1,.72.12,7.1,7.1,0,0,1,1.2.45,6.89,6.89,0,0,1,1.75,1.23c.88.86,1.16,1.58,1.1,1.61s-.51-.54-1.41-1.26a7.88,7.88,0,0,0-1.7-1,6.18,6.18,0,0,0-1.1-.37c-.41-.12-.76-.14-.87,0s0,.1,0,.22a2.08,2.08,0,0,0,.43.35,8.94,8.94,0,0,0,1,.61,10.5,10.5,0,0,0,1.86.78A12.88,12.88,0,0,1,184.52,463.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.27,463.65a3.19,3.19,0,0,1-.46-1.9,6.26,6.26,0,0,1,.86-3.28,1.61,1.61,0,0,1,1.27-.94.89.89,0,0,1,.8.56,2.8,2.8,0,0,1,.18.72,4.73,4.73,0,0,1,0,1.31,4.54,4.54,0,0,1-.89,2c-.79,1-1.59,1.19-1.6,1.12s.61-.44,1.22-1.39a4.56,4.56,0,0,0,.67-1.81,4.2,4.2,0,0,0,0-1.12c-.05-.41-.2-.75-.35-.71s-.53.29-.7.61a5.88,5.88,0,0,0-.51,1,7,7,0,0,0-.44,1.93C184.19,462.9,184.37,463.62,184.27,463.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.22 278.83 126.09 278.39 97.52 466.07 122.06 469.18 153.51 314.86 162.92 469.73 162.95 470.19 189.49 469.73 185.22 278.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.33,294a10.76,10.76,0,0,1,1.22-.08l3.56-.13,12.78-.36h.24v.25c0,3.71,0,7.85,0,12.26v.11l-.09.08-2.22,2-6.56,6-.18.16-.17-.15-8.75-7.8-.07-.06v-.1c0-3.72.08-6.79.11-9,0-1,0-1.81.05-2.42a4.89,4.89,0,0,1,.05-.82,8.77,8.77,0,0,1,0,.9c0,.62,0,1.45.06,2.47,0,2.17.06,5.19.11,8.86l-.07-.15,8.81,7.72h-.35l6.55-6,2.23-2-.09.2c0-4.41,0-8.55,0-12.26l.25.24-12.64.12h-4.58A1.5,1.5,0,0,1,158.33,294Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.5,293.23a8.19,8.19,0,0,1,1.09,0l3.18.26,11.5,1,.24,0,0,.24c-.43,3.63-.93,7.76-1.45,12.17l0,.11-.08.07-2.55,2-6.29,5-.21.16-.16-.2-6.87-8.7-.06-.07v-.09c.5-3.68.91-6.71,1.2-8.9.15-1,.26-1.79.35-2.41a3.67,3.67,0,0,1,.15-.8,7.9,7.9,0,0,1-.07.9q-.09.94-.24,2.46l-1,8.81,0-.16c2,2.51,4.38,5.44,6.95,8.63l-.37,0,6.28-5,2.55-2-.1.17c.55-4.4,1.07-8.53,1.52-12.16l.21.26-11.33-1.26-3.22-.39A9.78,9.78,0,0,1,130.5,293.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.68,321.71a16.93,16.93,0,0,1-2.68-1.3c-1.63-.85-3.88-2-6.39-3.27s-4.79-2.34-6.45-3.13a18.32,18.32,0,0,1-2.66-1.36,14.71,14.71,0,0,1,2.81,1c1.71.7,4,1.74,6.55,3s4.74,2.49,6.32,3.43A15.86,15.86,0,0,1,166.68,321.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.92,326.27a5.92,5.92,0,0,1-2-.76,17.18,17.18,0,0,1-7.33-7.22,5.93,5.93,0,0,1-.79-2,30.26,30.26,0,0,0,4.28,5.8A31.09,31.09,0,0,0,165.92,326.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.61,380.5a3.29,3.29,0,0,1-.27,1,13.28,13.28,0,0,1-1.23,2.49,15,15,0,0,1-15.94,6.72,13.44,13.44,0,0,1-2.64-.85,3.4,3.4,0,0,1-.89-.49,37.16,37.16,0,0,0,3.6,1,15.36,15.36,0,0,0,15.55-6.55C182.08,381.86,182.51,380.46,182.61,380.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.72,378.9a7.07,7.07,0,0,1-2.26,1,21.89,21.89,0,0,1-5.88,1,31,31,0,0,1-5.94-.35,9.9,9.9,0,0,1-2.41-.55c0-.19,3.74.53,8.33.36a27.63,27.63,0,0,0,5.8-.8C177.81,379.17,178.69,378.82,178.72,378.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.76,380a9.67,9.67,0,0,1-2.06,1.86,23.81,23.81,0,0,1-5.89,3.2,24.12,24.12,0,0,1-6.55,1.44,9.56,9.56,0,0,1-2.78-.07c0-.09,1.06-.1,2.74-.31a28.38,28.38,0,0,0,12.26-4.57A26.26,26.26,0,0,1,134.76,380Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,379.79a13.07,13.07,0,0,1-5.42.45,13.39,13.39,0,0,1-5.29-1.3c0-.16,2.38.53,5.33.76S129.55,379.63,129.57,379.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.16,316.16a12.23,12.23,0,0,1-2.66,1.2,37.09,37.09,0,0,1-6.82,1.77,36.59,36.59,0,0,1-7,.45,12.26,12.26,0,0,1-2.9-.31,21.64,21.64,0,0,1,2.9-.07,48.05,48.05,0,0,0,13.74-2.2A22,22,0,0,1,153.16,316.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.54,310.1c.15,0,.28.46.29,1s-.11,1-.26,1-.27-.46-.28-1S151.39,310.1,151.54,310.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.55,305.94c.15,0,.27.47.26,1s-.12,1-.27,1-.27-.47-.27-1S151.4,305.94,151.55,305.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.63,301.79c.15,0,.26.47.25,1s-.15,1-.3,1-.26-.47-.24-1S151.49,301.78,151.63,301.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.8,297.63c.15,0,.25.48.22,1.05s-.16,1-.31,1-.25-.48-.23-1S151.65,297.62,151.8,297.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.05,293.48c.15,0,.24.48.2,1.06s-.19,1-.34,1-.24-.49-.2-1.06S151.9,293.47,152.05,293.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.37,289.34c.15,0,.23.48.19,1.05s-.21,1-.36,1-.23-.49-.18-1.06S152.23,289.32,152.37,289.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.7,285.94c.15,0,.24.33.2.69s-.18.65-.33.64-.24-.33-.2-.69S152.55,285.93,152.7,285.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.27,465.06c.15,0,.18.51.06,1.08s-.32,1-.47,1-.17-.51-.06-1.07S119.13,465,119.27,465.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.09,461c.14,0,.17.51.06,1.07s-.32,1-.47,1-.17-.51-.06-1.08S119.94,461,120.09,461Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9,456.91c.15,0,.18.51.06,1.07s-.32,1-.46,1-.18-.51-.07-1.07S120.76,456.88,120.9,456.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.72,452.83c.15,0,.17.51.06,1.08s-.32,1-.47,1-.17-.51-.06-1.07S121.57,452.81,121.72,452.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.53,448.76c.15,0,.18.51.07,1.07s-.33,1-.47,1-.18-.51-.06-1.08S122.39,448.73,122.53,448.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.35,444.68c.15,0,.17.51.06,1.07s-.32,1-.47,1-.17-.51-.06-1.07S123.2,444.65,123.35,444.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.17,440.61c.14,0,.17.5.06,1.07s-.33,1-.47,1-.18-.51-.06-1.07S124,440.58,124.17,440.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,436.53c.15,0,.17.51.06,1.07s-.32,1-.47,1-.17-.51-.06-1.08S124.83,436.5,125,436.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.8,432.45c.14,0,.17.51.06,1.07s-.32,1-.47,1-.18-.51-.06-1.07S125.65,432.42,125.8,432.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.61,428.38c.15,0,.18.5.06,1.07s-.32,1-.47,1-.17-.51-.06-1.07S126.47,428.35,126.61,428.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.43,424.3c.14,0,.17.51.06,1.07s-.32,1-.47,1-.17-.51-.06-1.08S127.28,424.27,127.43,424.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.24,420.22c.15,0,.18.51.06,1.07s-.32,1-.46,1-.18-.51-.07-1.07S128.1,420.19,128.24,420.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.06,416.15c.14,0,.17.51.06,1.07s-.32,1-.47,1-.17-.51-.06-1.07S128.91,416.12,129.06,416.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.87,412.07c.15,0,.18.51.07,1.07s-.33,1-.47,1-.18-.51-.07-1.07S129.73,412,129.87,412.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69,408c.15,0,.17.51.06,1.08s-.32,1-.47,1-.17-.51-.06-1.07S130.54,408,130.69,408Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5,403.92c.15,0,.18.51.07,1.07s-.33,1-.47,1-.18-.5-.06-1.07S131.36,403.89,131.5,403.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.32,399.84c.15,0,.17.51.06,1.07s-.32,1-.47,1-.17-.51-.06-1.07S132.17,399.81,132.32,399.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.14,395.76c.14,0,.17.51.06,1.08s-.33,1-.47,1-.18-.51-.06-1.07S133,395.73,133.14,395.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,391.69c.15,0,.18.51.06,1.07s-.32,1-.47,1-.17-.51-.06-1.08S133.8,391.66,134,391.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.77,387.61c.14,0,.17.51.06,1.07s-.32,1-.47,1-.18-.51-.06-1.07S134.62,387.58,134.77,387.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.58,383.53c.15,0,.18.51.06,1.08s-.32,1-.47,1-.17-.51-.06-1.07S135.44,383.5,135.58,383.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.4,379.46c.14,0,.17.51.06,1.07s-.32,1-.47,1-.17-.51-.06-1.08S136.25,379.43,136.4,379.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,375.38c.15,0,.18.51.06,1.07s-.32,1-.46,1-.18-.51-.07-1.07S137.07,375.35,137.21,375.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,371.3c.15,0,.17.51.06,1.08s-.32,1-.47,1-.17-.51-.06-1.07S137.88,371.27,138,371.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.84,367.23c.15,0,.18.51.07,1.07s-.33,1-.47,1-.18-.51-.07-1.08S138.7,367.2,138.84,367.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.66,363.15c.15,0,.17.51.06,1.07s-.32,1-.47,1-.17-.51-.06-1.07S139.51,363.12,139.66,363.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.48,359.07c.14,0,.17.51.06,1.08s-.33,1-.47,1-.18-.51-.06-1.07S140.33,359.05,140.48,359.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.29,355c.15,0,.17.51.06,1.07s-.32,1-.47,1-.17-.51-.06-1.08S141.14,355,141.29,355Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.11,350.92c.14,0,.17.51.06,1.07s-.33,1-.47,1-.18-.51-.06-1.07S142,350.89,142.11,350.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.92,346.85c.15,0,.18.5.06,1.07s-.32,1-.47,1-.17-.51-.06-1.07S142.78,346.82,142.92,346.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.74,342.77c.14,0,.17.51.06,1.07s-.32,1-.47,1-.17-.51-.06-1.08S143.59,342.74,143.74,342.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.55,338.69c.15,0,.18.51.06,1.07s-.32,1-.47,1-.17-.51-.06-1.07S144.41,338.66,144.55,338.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.37,334.62c.14,0,.17.51.06,1.07s-.32,1-.47,1-.17-.51-.06-1.07S145.22,334.59,145.37,334.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.18,330.54c.15,0,.18.51.07,1.07s-.33,1-.47,1-.18-.51-.07-1.07S146,330.51,146.18,330.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,326.46c.15,0,.17.51.06,1.07s-.32,1-.47,1-.17-.51-.06-1.07S146.85,326.43,147,326.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.81,322.39c.15,0,.18.51.07,1.07s-.33,1-.47,1-.18-.5-.06-1.07S147.67,322.36,147.81,322.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.63,318.31c.15,0,.17.51.06,1.07s-.32,1-.47,1-.17-.51-.06-1.07S148.48,318.28,148.63,318.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.14,192.59s6.92-10.37,7.11-10.46h0s6.24-10.52,8.32-10.52,1.33,2.13-.82,5.9a15,15,0,0,0-2.07,5.37l5.13,3.09s3.43-1.32,3.57,1.87a21.72,21.72,0,0,1-.59,4.34c-.21,1.14-.72,2.35-1.8,1.92a1.33,1.33,0,0,1-.91-1.28c-.07-1.89.28-2.59,0-2.59s-3.69,9.91-3.69,9.91Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.11,184.45a9.83,9.83,0,0,1,1.65-1,3.37,3.37,0,0,1,1.87-.29,1.51,1.51,0,0,1,1.24,2.13,5.1,5.1,0,0,1-.85,1.41",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.77,182.36a9.88,9.88,0,0,1,1.56-.93,3.2,3.2,0,0,1,1.77-.27,1.55,1.55,0,0,1,1,.52,1.58,1.58,0,0,1,.19,1.48,13.57,13.57,0,0,1-1.6,2.06",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.56,186.74l-10,21.38,11,11.27,5.74-15.94s3.08.61,4.34-1.43c1.4-2.28,3.24-8.86,3.24-8.86Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.7,186.15a5.43,5.43,0,0,1,1.18-3,5.3,5.3,0,0,1,1.72-1.52c.51-.27.86-.37.89-.31s-1.2.8-2.17,2.15S239.87,186.22,239.7,186.15Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.79,186.24c0,.07-.39-.12-1-.22a3.35,3.35,0,0,0-2.18.34A5.32,5.32,0,0,0,246,188c-.35.5-.59.81-.66.77s.05-.4.34-1a4.41,4.41,0,0,1,1.69-1.89,3.24,3.24,0,0,1,2.54-.23C250.55,185.87,250.83,186.19,250.79,186.24Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.07,183.22a14.34,14.34,0,0,0-2.35,1.38c-1.12,1-1.67,2.15-1.82,2.08a3.8,3.8,0,0,1,1.46-2.48,4.23,4.23,0,0,1,1.84-1C246.73,183.12,247.06,183.16,247.07,183.22Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.53,187.84c.14-.05.4.78-.13,1.6s-1.38,1-1.39.81.54-.44.94-1.09S249.37,187.86,249.53,187.84Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.17,192.18s-.35-6.38,1.19-7.83,6,.06,6,.06",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,181.37a17.26,17.26,0,0,1-2.29,3.63,17.52,17.52,0,0,1-2.72,3.32,33.73,33.73,0,0,1,5-6.95Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.43,133l-.15,49.79,21.36,1,.62-12.11s7.59,1.51,9.54-5.54c1.26-4.5.94-39.29.94-39.29Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.55,130.36c-3.36,1-4.09,6.47-4.09,6.47l-5.28,11.65c-2.69-2.1-6.3-2-7,2.75-.5,3.41,3.75,4.1,3.75,4.1-2.47,4.21-4.15,7.61-7.75,11.61-3.89,4.33-6.07,4.76-10.3,4.83h-4.65s-2.28-7.4-6.5-25.9c-4.69-20.53,19.59-17.89,24.09-23.13C174.17,114.21,195.16,127.33,184.55,130.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.19,147.8c-3.94-2.64-4.29-10-2-14.47a14.23,14.23,0,0,1,12.12-7.54,5.75,5.75,0,0,0,2-.22,5.47,5.47,0,0,0,2.12-2c3.52-4.57,7-9.06,13.53-9.06a7.46,7.46,0,0,1,4.12,1,6.43,6.43,0,0,1,2.48,3.28,13.63,13.63,0,0,1,3.83-1.38,4.74,4.74,0,0,1,3.85.93,2.9,2.9,0,0,1,.6,3.69,4.65,4.65,0,0,1,4.65,3.87c.35,2.19-2.78,3.73-3.11,3.9,0,0,1.72,3.6-2.38,5.76-1.65.86-3.8-.18-4-.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.79,152.59a7.39,7.39,0,0,1-.12,3.78,7.54,7.54,0,0,1-1.51,3.47c-.15-.07.54-1.6,1-3.59S158.63,152.59,158.79,152.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.37,150.15a8.84,8.84,0,0,1-.2,3.64,9.41,9.41,0,0,1-1.12,3.47,18.9,18.9,0,0,1,.59-3.57A20.18,20.18,0,0,1,161.37,150.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.77,141.93c0,.07-.55.51-1.32,1.41a13.47,13.47,0,0,0-2.3,4,32.56,32.56,0,0,0-1.28,4.47,7.38,7.38,0,0,1-.53,1.89,6.88,6.88,0,0,1,.15-2,21.89,21.89,0,0,1,1.15-4.6,11.65,11.65,0,0,1,2.53-4A4,4,0,0,1,168.77,141.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.76,136.33a3,3,0,0,1,.42,1.35,9,9,0,0,1-1.63,6.49c-.52.7-1,1-1,1a18.6,18.6,0,0,0,1.92-4.21A18.5,18.5,0,0,0,171.76,136.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.27,148.77c-.08.13-.73-.1-1.47-.51s-1.27-.84-1.19-1,.72.09,1.46.5S146.34,148.64,146.27,148.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.59,143.45a3,3,0,0,1-.61,2.17c-.66,1.1-1.55,1.66-1.64,1.55s.57-.82,1.17-1.83S156.43,143.42,156.59,143.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.76,141.75a4.29,4.29,0,0,1-.95,2.59c-.86,1.3-1.93,2-2,1.88a23.21,23.21,0,0,1,1.57-2.18A21.53,21.53,0,0,1,159.76,141.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.54,120.9s-.41-.31-1.18-.75a8,8,0,0,0-3.58-.92,9.57,9.57,0,0,0-5.25,1.41,13,13,0,0,0-4.47,5,22.84,22.84,0,0,0-1.82,4.67l-.08.31-.29-.15a10.65,10.65,0,0,0-4.76-1.22,11.27,11.27,0,0,0-3.88.59,16.5,16.5,0,0,0-3.17,1.58,3.32,3.32,0,0,1,.71-.63,10,10,0,0,1,2.35-1.26,11.11,11.11,0,0,1,4-.72,10.94,10.94,0,0,1,5,1.2l-.38.17a22.47,22.47,0,0,1,1.84-4.8,13.3,13.3,0,0,1,4.7-5.15,9.76,9.76,0,0,1,5.52-1.37,7.71,7.71,0,0,1,3.67,1.13,5.38,5.38,0,0,1,.82.65C175.47,120.79,175.55,120.88,175.54,120.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.77,123.61s.59-.16,1.23.55a2.18,2.18,0,0,1,.49,1.56,2.43,2.43,0,0,1-1.24,1.77,3.53,3.53,0,0,1-2.6.36,7.4,7.4,0,0,1-2.68-1.3,26.22,26.22,0,0,0-2.62-1.79,10.62,10.62,0,0,0-3.15-1.11,13.36,13.36,0,0,0-6.44.44,17.62,17.62,0,0,0-4.76,2.42,46.35,46.35,0,0,0-3.81,3.22,5.42,5.42,0,0,1,.85-1.06,20.83,20.83,0,0,1,2.73-2.47,16.94,16.94,0,0,1,4.83-2.58,13.42,13.42,0,0,1,6.7-.5,11.14,11.14,0,0,1,3.31,1.17,24.63,24.63,0,0,1,2.65,1.86,7.24,7.24,0,0,0,2.49,1.26,3.12,3.12,0,0,0,2.31-.25,2.12,2.12,0,0,0,1.13-1.48,1.93,1.93,0,0,0-.36-1.39A1.86,1.86,0,0,0,186.77,123.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.69,188l-19.08,32c-2.14,3.74-4.11,7.72-6,11.85a13.26,13.26,0,0,0,2,12.41l-.54-.78a11.16,11.16,0,0,0,8.67,4.14h.5a11.14,11.14,0,0,0,10.21-6.7l6.13-9.3Z",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.26,181.88c-5.12-2.62-10.18-3.21-15.7-3.37-6.42-.19-15.48-1.09-22.41-.35,0,0-19.72,1.46-21.09,15l2.69,63.5-4.52,26.9,63.23,1.91L186,253.71c.78-16.51-.88-39.9-.88-39.9,1-8.88,5.83-12.87,6.52-18.65C192.25,190.06,188.83,184.21,184.26,181.88Z",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.44,257.55a5.07,5.07,0,0,1-.93.88,20.49,20.49,0,0,1-2.88,2,23,23,0,0,1-22.21.39,20.7,20.7,0,0,1-2.95-1.87,5.46,5.46,0,0,1-1-.85c.06-.09,1.46,1.1,4.08,2.38a23.81,23.81,0,0,0,21.85-.39C165,258.7,166.37,257.47,166.44,257.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,193.86a2.87,2.87,0,0,1,.07.62c0,.47.07,1.05.11,1.78.07,1.61.18,3.82.3,6.52.24,5.58.55,13.17.9,21.55s.73,16,1,21.54c.14,2.7.25,4.91.33,6.52,0,.73.06,1.31.08,1.78a2.71,2.71,0,0,1,0,.62,2.79,2.79,0,0,1-.1-.61c-.05-.47-.11-1.05-.18-1.77-.15-1.54-.31-3.77-.5-6.52-.38-5.51-.78-13.12-1.14-21.54s-.6-16-.74-21.55c0-2.71-.1-4.92-.13-6.54,0-.72,0-1.31,0-1.77A2.83,2.83,0,0,1,125,193.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,197.23a1.79,1.79,0,0,1-.22.49l-.71,1.37c-.64,1.18-1.59,2.87-2.81,4.93-2.4,4.15-6,9.71-9.65,16-1.83,3.16-3.37,6.28-4.71,9.13a16.83,16.83,0,0,0-1.84,8,12.94,12.94,0,0,0,1.47,5.36c.62,1.17,1.14,1.71,1.09,1.75a2.58,2.58,0,0,1-.38-.38,9.71,9.71,0,0,1-.9-1.27,12.43,12.43,0,0,1-1.66-5.44,16.86,16.86,0,0,1,1.76-8.24c1.33-2.89,2.86-6,4.7-9.2,3.66-6.34,7.31-11.85,9.79-16,1.22-2,2.22-3.62,2.95-4.84.33-.52.59-1,.81-1.31S121,197.22,121,197.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.3,214.66l-14.63-9.57-9.24,16s-12.8-17.79-18.61-28.21c-5.36-9.6-12.28-12.18-15.62-12.88a1.48,1.48,0,0,0-1.77,1.62l5,34.6c.64,1.8,11.2,17.11,17.1,24.81,9.85,12.86,24.36,4.63,28.34-4.37C231.08,229.51,236,218.66,237.3,214.66Z",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.64,235.52a9.82,9.82,0,0,1-.28-2.28,43.5,43.5,0,0,0-.71-5.45,18,18,0,0,0-1.87-5.11c-.68-1.21-1.27-1.87-1.2-1.93a5.44,5.44,0,0,1,1.53,1.73,15.41,15.41,0,0,1,2.07,5.2,28.84,28.84,0,0,1,.56,5.54A9.22,9.22,0,0,1,217.64,235.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.92,228.37c-.09,0-.16-.74-.52-1.87a10.29,10.29,0,0,0-2.34-3.92,6.1,6.1,0,0,0-3.89-2.13,5.73,5.73,0,0,0-1.85.32c-.06,0,.55-.66,1.86-.7a6,6,0,0,1,4.27,2.13,9.26,9.26,0,0,1,2.32,4.19A4.23,4.23,0,0,1,221.92,228.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.25,184.27a2.25,2.25,0,0,1-.36.4l-.45.46c-.16.21-.35.43-.56.68a14.32,14.32,0,0,0-2.53,4.92,19.13,19.13,0,0,0-.55,8.16,18.07,18.07,0,0,0,1.25,4.68,51.76,51.76,0,0,0,2.37,4.7c3.58,6.29,7.27,11.73,9.93,15.66,1.32,1.9,2.41,3.46,3.22,4.61a20.59,20.59,0,0,1,1.16,1.71s-.14-.12-.37-.39-.56-.66-1-1.19c-.83-1-2-2.59-3.36-4.52A185.49,185.49,0,0,1,177,208.53a49.09,49.09,0,0,1-2.39-4.75A18.58,18.58,0,0,1,173.3,199a19.19,19.19,0,0,1,.69-8.35,13.69,13.69,0,0,1,2.73-4.94l.61-.65.49-.43C178.09,184.36,178.23,184.25,178.25,184.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.28,276.19a1.62,1.62,0,0,1-.44.19l-1.32.46c-.57.2-1.27.42-2.1.64s-1.77.52-2.82.74a71.09,71.09,0,0,1-7.47,1.37,73.35,73.35,0,0,1-18.57.06,74.67,74.67,0,0,1-7.47-1.33c-1.06-.22-2-.5-2.83-.73s-1.53-.43-2.11-.63l-1.31-.45c-.3-.1-.46-.17-.45-.19a2.64,2.64,0,0,1,.48.09l1.34.35c.58.16,1.29.35,2.13.54s1.77.45,2.83.64c2.1.46,4.63.87,7.45,1.21a85.15,85.15,0,0,0,9.23.51,87,87,0,0,0,9.22-.56c2.82-.35,5.34-.78,7.44-1.25,1.06-.2,2-.46,2.83-.66s1.54-.39,2.12-.55l1.34-.36A1.47,1.47,0,0,1,178.28,276.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "123.82 238.91 126.67 234.48 125.18 199.59 123.82 238.91"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.13,197.23s.09,12.71,3,17.75S186,230.9,186,230.25s-.39-9-.39-9S173.19,204.34,173.13,197.23Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M121.29,240a2.13,2.13,0,0,1-.91.27,5.49,5.49,0,0,1-2.58-.34,8.53,8.53,0,0,1-3.19-2.14,18.47,18.47,0,0,1-2.67-3.85,38.37,38.37,0,0,0-2.36-4,11.16,11.16,0,0,0-2.61-2.62,8.25,8.25,0,0,0-3.16-1.25,2.5,2.5,0,0,1,1,0,6.37,6.37,0,0,1,2.42.93,11.18,11.18,0,0,1,2.79,2.64,34.83,34.83,0,0,1,2.42,4,19.65,19.65,0,0,0,2.56,3.78,8.75,8.75,0,0,0,3,2.13A6.48,6.48,0,0,0,121.29,240Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.16,218.06c-.09,0-.31-.76-.92-1.88a11.76,11.76,0,0,0-7.7-5.82c-1.25-.28-2.06-.28-2.06-.37a5,5,0,0,1,2.12,0,10.81,10.81,0,0,1,8,6A5,5,0,0,1,125.16,218.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.36,199.33s-.69-.13-1.93-.23a16.58,16.58,0,0,0-5.22.47,31.57,31.57,0,0,0-7.26,2.9c-2.62,1.37-5.39,3.11-8.53,4.55a26,26,0,0,1-9.39,2.39,26.46,26.46,0,0,1-7.89-.73,23.32,23.32,0,0,1-5-1.84c-.57-.27-1-.54-1.27-.7s-.43-.27-.42-.29.64.3,1.78.8a26.27,26.27,0,0,0,5,1.67,27.08,27.08,0,0,0,7.77.61,26.39,26.39,0,0,0,9.21-2.38c3.09-1.42,5.87-3.14,8.52-4.5a29.58,29.58,0,0,1,7.39-2.83,15.37,15.37,0,0,1,5.33-.32,10.24,10.24,0,0,1,1.43.27A1.71,1.71,0,0,1,173.36,199.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.65,233.93a2.4,2.4,0,0,1-.57.19,14.93,14.93,0,0,1-1.7.42,27.14,27.14,0,0,1-6.39.51,48.84,48.84,0,0,1-9.42-1.32c-3.5-.8-7.26-1.95-11.21-3.11a76.68,76.68,0,0,0-11.3-2.51,34.91,34.91,0,0,0-9.4-.07,22.73,22.73,0,0,0-6.11,1.68c-1.37.6-2.1,1-2.12,1a2.34,2.34,0,0,1,.5-.34c.36-.18.84-.53,1.54-.83a21.87,21.87,0,0,1,6.14-1.86,34.51,34.51,0,0,1,9.51,0,73,73,0,0,1,11.38,2.49c4,1.16,7.71,2.32,11.18,3.14a49.6,49.6,0,0,0,9.32,1.42,29.84,29.84,0,0,0,6.35-.34C184.83,234.09,185.64,233.88,185.65,233.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,253.71a27.34,27.34,0,0,0-8.32-2.24,41.1,41.1,0,0,0-9.36.32c-3.51.48-7.33,1.28-11.36,2s-7.89,1.42-11.45,1.73a44.08,44.08,0,0,1-9.46-.06,27.26,27.26,0,0,1-6.21-1.49c-.71-.24-1.23-.53-1.59-.68a2.53,2.53,0,0,1-.54-.28c0-.05.78.29,2.2.77a30.19,30.19,0,0,0,6.18,1.31,45.35,45.35,0,0,0,9.38,0c3.52-.33,7.37-1,11.4-1.76s7.85-1.55,11.39-2a39.23,39.23,0,0,1,9.46-.22,23,23,0,0,1,6.19,1.56,14.16,14.16,0,0,1,1.57.75A2.79,2.79,0,0,1,186,253.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,279.21a5.2,5.2,0,0,1-1-.63c-.62-.44-1.52-1.06-2.65-1.8a81.2,81.2,0,0,0-9.14-5.23,82.13,82.13,0,0,0-9.77-4c-1.28-.43-2.32-.75-3-1a4.62,4.62,0,0,1-1.11-.4,5.65,5.65,0,0,1,1.16.2c.75.16,1.81.44,3.11.82a65.32,65.32,0,0,1,19,9.25c1.11.78,2,1.45,2.56,1.94A5,5,0,0,1,153.5,279.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.28,278.87a6.51,6.51,0,0,1-2.1,1.05,15.36,15.36,0,0,1-11.16-.34,6.81,6.81,0,0,1-2-1.18,23,23,0,0,1,2.17.84,18.41,18.41,0,0,0,5.43,1,17.87,17.87,0,0,0,5.48-.71C183.43,279.17,184.24,278.79,184.28,278.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.17,212.85a2.23,2.23,0,0,1-.12.89,6,6,0,0,1-1.17,2.15,10.07,10.07,0,0,1-2.81,2.28,32.43,32.43,0,0,1-4,1.8,17.16,17.16,0,0,0-3.8,2,7.79,7.79,0,0,0-2.26,2.6,5.88,5.88,0,0,0-.64,3.1,1.7,1.7,0,0,1-.2-.87,5,5,0,0,1,.51-2.4,7.8,7.8,0,0,1,2.29-2.81,16.24,16.24,0,0,1,3.9-2.09,39.78,39.78,0,0,0,4-1.74,10.67,10.67,0,0,0,2.76-2.1A7.86,7.86,0,0,0,206.17,212.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.88,191.63a3.06,3.06,0,0,1-.17.91,6.69,6.69,0,0,1-.31,1,12.28,12.28,0,0,1-.51,1.34,20,20,0,0,1-1.8,3.28,22.82,22.82,0,0,1-3,3.48,22.24,22.24,0,0,1-3.66,2.76,19.74,19.74,0,0,1-3.38,1.6,13.1,13.1,0,0,1-1.37.43,7.19,7.19,0,0,1-1,.24,3.48,3.48,0,0,1-.92.12c0-.1,1.27-.35,3.21-1.14A22.37,22.37,0,0,0,184.2,204a22.51,22.51,0,0,0,6.49-6.11,21.2,21.2,0,0,0,1.86-3.15C193.46,192.87,193.78,191.6,193.88,191.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.63,178.51a10.07,10.07,0,0,1-1.45.65c-.94.4-2.34.9-4.09,1.45s-3.86,1.09-6.24,1.58a64,64,0,0,1-15.7,1.15,62.43,62.43,0,0,1-6.41-.65c-1.81-.29-3.26-.58-4.26-.84a8.68,8.68,0,0,1-1.53-.43,9.76,9.76,0,0,1,1.58.24c1,.19,2.46.43,4.26.66s4,.44,6.38.54a74.65,74.65,0,0,0,7.83-.13,75.62,75.62,0,0,0,7.76-1c2.36-.46,4.48-1,6.23-1.47s3.16-.94,4.12-1.28A9.71,9.71,0,0,1,174.63,178.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.92,222a3.4,3.4,0,0,1,.36,1,14.64,14.64,0,0,1,.43,2.89,41.82,41.82,0,0,1-1,9.57,25.56,25.56,0,0,1-1.36,5.14,11.45,11.45,0,0,1-2.32,3.69,7.68,7.68,0,0,1-2.38,1.73,2.74,2.74,0,0,1-1,.32,10.27,10.27,0,0,0,3.13-2.3,11.68,11.68,0,0,0,2.15-3.62,27.67,27.67,0,0,0,1.29-5.06,49.2,49.2,0,0,0,1.13-9.45A34.45,34.45,0,0,0,213.92,222Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,224.6c-.09,0-.56-1-1.6-2.54a20.8,20.8,0,0,0-5.06-5.08,20.54,20.54,0,0,0-6.51-3c-1.79-.46-3-.54-2.94-.63a2.2,2.2,0,0,1,.82,0,13,13,0,0,1,2.2.3,17.5,17.5,0,0,1,3.17,1,18.65,18.65,0,0,1,6.61,4.62,18.28,18.28,0,0,1,2,2.63,12.55,12.55,0,0,1,1,2A2.53,2.53,0,0,1,234,224.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.21,277a1.85,1.85,0,0,0,.7-2.72,3.49,3.49,0,0,0-2.88-1c-5.17.1-9.68,3.56-14.76,4.49-3.86.7-7.85-.09-11.61-1.23s-7.43-2.63-11.29-3.36a5.44,5.44,0,0,0-2.44-.06,2.13,2.13,0,0,0-1.63,1.66c-.1.81.09,1.42,1.31,1.83,0,0,12.79,3.56,22,3.42A98.14,98.14,0,0,0,175.21,277Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-34"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.93,
    y: 423.77,
    width: 69.76,
    height: 9.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.81,433.48h-70v-9.83h70Zm-69.76-.24h69.52v-9.35H372.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.4 430.17 388.44 479.7 425.6 479.7 435.3 433.36 378.4 430.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.4 475.02 383.76 482.38 428.92 482.38 435.3 475.02 378.4 475.02",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.19,431.61c-.13,0-.31-22.95-.39-51.25s0-51.26.11-51.26.31,22.94.39,51.26S404.33,431.61,404.19,431.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.73,374.18a2.24,2.24,0,0,1-.18.53c-.17.39-.37.89-.63,1.49l-.45,1.07c-.15.4-.3.84-.47,1.3s-.34,1-.53,1.5-.34,1.1-.52,1.7a69.45,69.45,0,0,0-1.95,8.54A103,103,0,0,0,413.92,401a143.92,143.92,0,0,0,.55,19.51c.22,2.49.45,4.51.62,5.9.07.65.13,1.18.17,1.6a2,2,0,0,1,0,.56,2.06,2.06,0,0,1-.13-.55l-.27-1.59c-.22-1.38-.5-3.39-.77-5.88a128.6,128.6,0,0,1-.7-19.57,95.36,95.36,0,0,1,1.13-10.73,64.11,64.11,0,0,1,2.06-8.57c.2-.6.36-1.18.56-1.71l.57-1.49.51-1.29c.17-.39.35-.74.5-1.06l.71-1.45A2.41,2.41,0,0,1,419.73,374.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,355.62a4.06,4.06,0,0,1-.22.76c-.18.53-.42,1.24-.73,2.13l-.53,1.54c-.18.57-.36,1.19-.56,1.85-.41,1.33-.88,2.84-1.3,4.54-.23.84-.46,1.73-.7,2.65s-.43,1.9-.66,2.9c-.49,2-.84,4.17-1.29,6.44-.77,4.55-1.44,9.59-1.91,14.91s-.63,10.4-.7,15,0,8.79.24,12.29c.06,1.75.17,3.33.26,4.71s.17,2.58.25,3.56.13,1.69.18,2.25a4.18,4.18,0,0,1,0,.78,3.75,3.75,0,0,1-.12-.77c-.07-.56-.16-1.31-.27-2.24s-.23-2.17-.34-3.56-.25-3-.34-4.71c-.23-3.5-.33-7.67-.34-12.31s.22-9.73.67-15.06,1.16-10.39,1.95-14.95c.47-2.28.83-4.45,1.34-6.45.24-1,.46-2,.68-2.9s.5-1.81.74-2.66c.44-1.69.94-3.2,1.37-4.52.22-.66.42-1.28.6-1.85s.4-1.06.58-1.52l.81-2.11A4.53,4.53,0,0,1,418,355.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.78,435.67a1.14,1.14,0,0,1,0-.27c0-.2,0-.46-.06-.79l-.21-3c-.17-2.68-.4-6.49-.7-11.18-.6-9.44-1.48-22.48-3.07-36.82-.81-7.16-1.75-14-2.73-20.14-.52-3.09-1-6-1.53-8.75s-1-5.26-1.5-7.58-1-4.39-1.38-6.22-.8-3.41-1.12-4.69l-.73-3c-.07-.31-.13-.57-.17-.77a1,1,0,0,1-.05-.27,1.1,1.1,0,0,1,.09.26c.06.2.14.45.23.76.19.7.47,1.69.81,2.93s.78,2.84,1.21,4.67,1,3.9,1.45,6.22,1.06,4.84,1.57,7.58,1,5.66,1.57,8.74c1,6.18,2,13,2.78,20.17,1.59,14.35,2.41,27.4,2.92,36.85.26,4.72.44,8.54.54,11.19,0,1.29.09,2.31.12,3,0,.32,0,.58,0,.79A1.1,1.1,0,0,1,399.78,435.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.62,340.13c-.3-3.25-3.58-5.7-6.85-5.73s-6.31,1.92-8.3,4.5a26,26,0,0,0-4,8.88c-2.2,7.66-3.4,15.71-2.46,23.62s4.15,15.7,9.82,21.3c.93.91,2.12,1.81,3.39,1.54a4,4,0,0,0,1.79-1.1,52.89,52.89,0,0,0,17.15-40.2c-.09-3-.48-6.14-2.15-8.64s-5.55-5.17-8.39-4.17",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.24,314.09l-4.6,8.33c-.1.19-.25.41-.47.43s-.42-.21-.55-.41l-12.16-18.66,2.8-1.59Z",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M379.24,314.09l-4.6,8.33c-.1.19-.25.41-.47.43s-.42-.21-.55-.41l-12.16-18.66,2.8-1.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M403.91,329.1l-41.48-24.47a2,2,0,0,1-1-1,1.93,1.93,0,0,1,.74-1.67,28.58,28.58,0,0,1,22.16-8.7,25.32,25.32,0,0,1,20,12.46c4,7.15,4.14,16.61-.45,23.4",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.41,296.81a2.5,2.5,0,0,1,.54-.06c.36,0,.89-.09,1.57-.08a31.59,31.59,0,0,1,5.75.46,33.51,33.51,0,0,1,8.2,2.49,33.67,33.67,0,0,1,18.65,21.8,31.81,31.81,0,0,1,1,5.68c.07.68.06,1.21.08,1.57a1.75,1.75,0,0,1,0,.54s-.09-.75-.26-2.09a34,34,0,0,0-27.74-29.65,36,36,0,0,0-5.69-.61C369.16,296.83,368.41,296.86,368.41,296.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.29,312.21a9.86,9.86,0,0,1-2.1,1c-1.32.52-3.16,1.19-5.23,1.84s-4,1.18-5.34,1.52a10.06,10.06,0,0,1-2.26.43,10.91,10.91,0,0,1,2.17-.77l5.28-1.65,5.27-1.7A10.5,10.5,0,0,1,398.29,312.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.76,294.66a17.67,17.67,0,0,1,.49,4.63,17.87,17.87,0,0,1-.25,4.65,27.63,27.63,0,0,1-.25-4.64A29.14,29.14,0,0,1,391.76,294.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.07,304.16a19,19,0,0,1,3-1.06c1.89-.58,4.51-1.32,7.43-2s5.6-1.25,7.54-1.59a17.69,17.69,0,0,1,3.17-.42,23.17,23.17,0,0,1-3.1.77c-1.92.43-4.57,1-7.49,1.72s-5.55,1.39-7.45,1.88A22.43,22.43,0,0,1,362.07,304.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.78,332.44c-3.57-2.71-7.34-3.24-11.81-3.06A36.09,36.09,0,0,0,360,332.71c-7,3.07-13.57,7.58-17.74,14s-5.64,14.85-2.51,21.81a3.09,3.09,0,0,0,1.42,1.72,3.35,3.35,0,0,0,2.34-.18c7.95-2.59,16-5.21,23.28-9.27s14-9.72,17.89-17.11a14.8,14.8,0,0,0,1.89-5.67,7,7,0,0,0-1.83-5.54",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.85,331.6a3.73,3.73,0,0,1-.57.23l-1.67.57-1.2.41c-.44.15-.91.35-1.41.55-1,.4-2.18.81-3.41,1.41l-1.95.88c-.68.32-1.35.7-2.07,1.07-1.44.7-2.9,1.61-4.45,2.53a75.72,75.72,0,0,0-9.42,7,77.61,77.61,0,0,0-8.13,8.45c-1.1,1.43-2.19,2.76-3.07,4.1-.46.66-.92,1.28-1.32,1.91l-1.13,1.83c-.75,1.14-1.3,2.25-1.83,3.19l-.73,1.33-.55,1.15-.78,1.58a2.71,2.71,0,0,1-.3.53,2.25,2.25,0,0,1,.21-.57l.7-1.63c.15-.35.33-.74.51-1.16s.44-.87.69-1.36c.51-1,1-2.08,1.78-3.24l1.11-1.85c.39-.64.85-1.27,1.3-1.95.87-1.35,1.95-2.7,3.06-4.14a67.85,67.85,0,0,1,17.66-15.54c1.57-.92,3.05-1.81,4.5-2.51.73-.36,1.41-.74,2.1-1l2-.87c1.25-.58,2.43-1,3.45-1.35l1.43-.51,1.22-.36,1.7-.49A2.74,2.74,0,0,1,384.85,331.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,346.69a83.89,83.89,0,0,1-8.67,2.79,82,82,0,0,1-8.82,2.32,84.62,84.62,0,0,1,8.68-2.79A82.91,82.91,0,0,1,357,346.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.63,365.84a13.27,13.27,0,0,1-.19-2.71c-.05-1.67-.06-4,0-6.53s.21-4.86.35-6.53a14.65,14.65,0,0,1,.34-2.68,15.21,15.21,0,0,1,0,2.7c0,1.84-.12,4.06-.2,6.52s-.12,4.69-.16,6.52A16.52,16.52,0,0,1,356.63,365.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,357.48c-.14,0-.57-4.69-1-10.49s-.62-10.51-.48-10.52.57,4.69,1,10.49S373.17,357.47,373,357.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.61,336a15.15,15.15,0,0,1,2.78-.09c1.72,0,4.09.07,6.7.15s5,.19,6.69.3a15.7,15.7,0,0,1,2.77.26,15,15,0,0,1-2.78.09c-1.71,0-4.08-.06-6.7-.15s-5-.19-6.69-.3A15.7,15.7,0,0,1,352.61,336Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.61,394.93a4.15,4.15,0,0,1-.06-.57c0-.42,0-1-.07-1.63-.06-1.41-.08-3.46,0-6s.21-5.54.51-8.88.79-7,1.46-10.8,1.51-7.41,2.36-10.65,1.76-6.12,2.59-8.51,1.54-4.32,2.09-5.63l.63-1.5a2.87,2.87,0,0,1,.25-.51,2.48,2.48,0,0,1-.15.55c-.15.4-.33.91-.55,1.53-.49,1.33-1.16,3.26-1.94,5.67s-1.63,5.29-2.48,8.52-1.63,6.82-2.31,10.61-1.15,7.44-1.49,10.76-.53,6.33-.62,8.86-.14,4.57-.14,6c0,.66,0,1.2,0,1.63A2.34,2.34,0,0,1,393.61,394.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,366.63a11,11,0,0,1-1.65,1.82c-1.08,1.07-2.6,2.5-4.34,4s-3.36,2.85-4.56,3.77a11.68,11.68,0,0,1-2,1.4A13.18,13.18,0,0,1,385,376l4.45-3.88,4.43-3.91A13,13,0,0,1,395.8,366.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.93,377.21a20.27,20.27,0,0,1-1.76-2.44l-4.1-6-4.19-5.92a19.3,19.3,0,0,1-1.67-2.5,17.11,17.11,0,0,1,2,2.29c1.15,1.46,2.69,3.52,4.31,5.85s3,4.49,4,6.08A16.2,16.2,0,0,1,408.93,377.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.05,344c.08.11-4.28,3.05-9.74,6.56s-9.93,6.25-10,6.13,4.29-3.05,9.74-6.55S402,343.83,402.05,344Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.35,357.22a80.61,80.61,0,0,1-6.6-6.09,81.94,81.94,0,0,1-6.25-6.46,84.26,84.26,0,0,1,6.6,6.1A80.9,80.9,0,0,1,414.35,357.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.44,357l3.74-.31a18.46,18.46,0,0,0,7.56-2.31,29.84,29.84,0,0,1,3.53-1.77c4.63-1.86,9.79-1.53,14.77-1.78a61.08,61.08,0,0,0,23.5-6,2.33,2.33,0,0,0,1-.93c.77-1.4-.66-2.65-1.89-3.41-6.31-3.89-12.73-7.82-19.88-9.75s-15.27-1.6-21.37,2.6c-7.17,4.93-9.78,15-11,23.66",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.65,343.39a4,4,0,0,1-.63-.3l-1.78-.93c-1.54-.81-3.75-2-6.55-3.34a60.83,60.83,0,0,0-10.15-3.91,33.31,33.31,0,0,0-13.14-1.07,22.47,22.47,0,0,0-12,5.15,26.61,26.61,0,0,0-6.24,8.76,73.16,73.16,0,0,0-2.72,6.83c-.27.78-.5,1.41-.66,1.89a3.57,3.57,0,0,1-.27.65,5.78,5.78,0,0,1,.17-.68l.58-1.92a59.48,59.48,0,0,1,2.58-6.91,26.43,26.43,0,0,1,6.26-9,22.72,22.72,0,0,1,12.22-5.29,33.67,33.67,0,0,1,13.34,1.11,59.27,59.27,0,0,1,10.17,4c2.79,1.39,5,2.63,6.5,3.49l1.73,1A3.07,3.07,0,0,1,471.65,343.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.66,348.22c-.08.11-5-3.06-10.93-7.08s-10.74-7.37-10.66-7.48,5,3,10.93,7.07S462.74,348.1,462.66,348.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,333.19a11.69,11.69,0,0,1-3.82.76,11.55,11.55,0,0,1-3.9-.05,23.06,23.06,0,0,1,3.85-.44A22.82,22.82,0,0,1,458,333.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,329.25a13.94,13.94,0,0,1-1.61,3.22,13.27,13.27,0,0,1-2,3,13.94,13.94,0,0,1,1.61-3.22A13.58,13.58,0,0,1,436,329.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.39,351.1a12.73,12.73,0,0,1-2.35-1.28c-1.42-.86-3.33-2.11-5.37-3.6s-3.85-2.88-5.14-3.91a15.46,15.46,0,0,1-2-1.74,13.47,13.47,0,0,1,2.24,1.46l5.22,3.79c2,1.48,3.91,2.78,5.27,3.71A15.7,15.7,0,0,1,440.39,351.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,372.86c-3.57-.94-7.82,2.53-8.56,6.15s.62,7.32,2.21,10.65A54.28,54.28,0,0,0,431.37,409c6.39,5.1,14.4,8.36,22.57,8.31-1.51-7,.4-14.33-.44-21.45a27.89,27.89,0,0,0-24.72-24.48c-2.28-.25-4.92-.61-5.83,1.5",
    style: {
      fill: "#1A76D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.94,417.29a2,2,0,0,1-.5-.23,9.12,9.12,0,0,1-1.34-.9,13.94,13.94,0,0,1-3.53-4.71c-.57-1.11-1.2-2.31-1.82-3.64s-1.25-2.75-1.92-4.25a42.74,42.74,0,0,0-2.36-4.53,35.75,35.75,0,0,0-3.25-4.42c-2.45-2.87-5.07-5.36-7.34-7.73a50.29,50.29,0,0,1-5.6-6.72,24.71,24.71,0,0,1-2.74-5.22,15.08,15.08,0,0,1-.47-1.53,3.8,3.8,0,0,1-.12-.55c.05,0,.25.73.77,2a27.2,27.2,0,0,0,2.85,5.09,53.39,53.39,0,0,0,5.63,6.6c2.29,2.35,4.93,4.83,7.4,7.73a35.83,35.83,0,0,1,3.28,4.48,40.27,40.27,0,0,1,2.36,4.61l1.88,4.26c.6,1.32,1.22,2.53,1.77,3.64a14.36,14.36,0,0,0,3.33,4.73C453.27,416.91,454,417.25,453.94,417.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.48,411.47a10.44,10.44,0,0,1,.33-2.41c.28-1.47.74-3.49,1.35-5.68s1.29-4.17,1.82-5.57a10.54,10.54,0,0,1,1-2.22,12.66,12.66,0,0,1-.64,2.34c-.44,1.42-1.05,3.39-1.67,5.58s-1.12,4.18-1.49,5.63A13.45,13.45,0,0,1,435.48,411.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.27,394.26a15,15,0,0,1-2.52-.58c-1.54-.4-3.66-.95-6-1.49s-4.52-.94-6.08-1.24a14.63,14.63,0,0,1-2.52-.55,12,12,0,0,1,2.58.2c1.58.21,3.76.57,6.13,1.11s4.5,1.14,6,1.63A11.43,11.43,0,0,1,453.27,394.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.23,399.26a13.61,13.61,0,0,1,.39-2.78c.31-1.71.81-4.05,1.48-6.61s1.38-4.85,1.93-6.49a13.82,13.82,0,0,1,1-2.62,18.77,18.77,0,0,1-.69,2.72c-.47,1.67-1.13,4-1.79,6.51s-1.22,4.88-1.62,6.56A17.17,17.17,0,0,1,422.23,399.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.08,379.26c0,.14-4.48-.23-10-.81a98.49,98.49,0,0,1-9.9-1.3c0-.13,4.47.23,9.95.81A99,99,0,0,1,445.08,379.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.81,433.32c0,.13-15.67.24-35,.24s-35-.11-35-.24,15.66-.25,35-.25S441.81,433.18,441.81,433.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.91,453.48c0,.14-10.56.25-23.58.25s-23.58-.11-23.58-.25,10.55-.25,23.58-.25S430.91,453.34,430.91,453.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.32,456.36c0,.14-10.56.25-23.58.25s-23.58-.11-23.58-.25,10.56-.25,23.58-.25S431.32,456.23,431.32,456.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.32,451.1c0,.14-10.92.25-24.39.25s-24.39-.11-24.39-.25,10.92-.24,24.39-.24S431.32,451,431.32,451.1Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.23,482.38c0,.15-94.58.26-211.22.26s-211.24-.11-211.24-.26,94.56-.26,211.24-.26S461.23,482.24,461.23,482.38Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.aee9817f0a5e0eb89062145cbc242900.svg";
export { ForwardRef as ReactComponent };